<div class="federated-modal">
  <div class="modal-content text-center">
    <div class="modal-body">
      <h1 class="font-light weight mb-4 default lh-40">Password cannot be reset.</h1>
      <p class="graylight font-light weight">Please contact your employer.</p>
    </div>
    <div class="pt-3 modal-footer">
      <button name="cancelButton" type="button" aria-label="Close" (click)="close()"
          class="btn btn-primary btn-block mt-0">Got it</button>
    </div>
  </div>
</div>